<template>
  <v-container>
    <v-card>
      <v-layout row wrap v-if="isLoading">
        <v-flex xs12 class="pa-2 animated-background"> </v-flex>
      </v-layout>
      <v-expansion-panel v-else>
        <v-expansion-panel-content v-for="(faq, i) in faqs" :key="i">
          <div slot="header" v-html="faq.question"></div>
          <v-card class="px-5 pb-2">
            <v-card-text class="pt-0" v-html="faq.answer"></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
  </v-container>
</template>

<script>
import faqService from '@/services/faqService';
import { EventBus } from '@/services/eventBus';
import store from '@/store';
import keys from '@/store/keys';
import utilService from '@/services/utilService';

export default {
  name: 'Faq',
  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.$i18n.t('page.description'),
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=573568924',
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords'),
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title'),
        },
        {
          property: 'twitter:card',
          content: 'photo',
        },
        {
          property: 'twitter:site',
          content: this.twitterHashtag,
        },
        {
          property: 'twitter:image',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'twitter:url',
          content: window.location.href,
        },
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title'),
        },
        {
          property: 'og:url',
          content: window.location.href,
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description'),
        },
        {
          property: 'og:image',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'og:image:secure_url',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'og:image:alt',
          content: this.$i18n.t('meta.og.image'),
        },
        {
          property: 'og:image:width',
          content: '1200',
        },
        {
          property: 'og:image:height',
          content: '586',
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg',
        },
      ],
    };
  },
  computed: {
    twitterHashtag() {
      return store.state.countrySelected.twitterHashtag;
    },
  },
  data() {
    return {
      faqs: [],
      isLoading: false,
    };
  },
  created() {
    this.loadFaqs();
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    async loadFaqs() {
      this.isLoading = true;
      let resp = await faqService.list();
      if (resp.error) {
      } else {
        this.faqs = resp.data;
      }
      this.isLoading = false;
    },
    async changeLanguage() {
      await this.loadFaqs();
    },
  },
};
</script>

<style lang="scss" scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 96px;
  position: relative;
}
</style>
